import { UUID_PATTERN } from '@/utils'

import WorkflowDetailView from '@/views/detail/WorkflowDetailView.vue'
import WorkflowVersionDetailView from '@/views/detail/WorkflowVersionDetailView.vue'
import WorkflowRunDetailView from '@/views/detail/WorkflowRunDetailView.vue'
import WorkflowImportView from '@/views/WorkflowImportView.vue'
import WorkflowImportROCrateView from '@/views/WorkflowImportROCrateView.vue'
import WorkflowRunImportGalaxyView from '@/views/WorkflowRunImportGalaxyView.vue'

const workflowRoutes = [
  {
    path: `/workflows/workflows/:modelType/import`,
    component: WorkflowImportView,
    name: 'workflowImport',
    props: (route) => ({
      ...route.params,
      appName: 'workflows',
      modelName: 'workflows',
    }),
  },
  {
    path: `/workflows/workflows/:modelType/import-ro-crate`,
    component: WorkflowImportROCrateView,
    name: 'workflowImportROCrate',
    props: (route) => ({
      ...route.params,
      appName: 'workflows',
      modelName: 'workflows',
    }),
  },
  {
    path: `/workflows/workflowruns/:modelType/:id(${UUID_PATTERN})`,
    component: WorkflowRunDetailView,
    name: 'workflowRunDetail',
    props: (route) => ({
      ...route.params,
      appName: 'workflows',
      modelName: 'workflowruns',
    }),
  },
  {
    path: `/workflows/workflowversions/:modelType/:id(${UUID_PATTERN})`,
    component: WorkflowVersionDetailView,
    name: 'workflowVersionDetail',
    props: (route) => ({
      ...route.params,
      appName: 'workflows',
      modelName: 'workflowversions',
    }),
  },
  {
    path: `/workflows/:modelName/:modelType/:id(${UUID_PATTERN})`,
    component: WorkflowDetailView,
    name: 'workflowDetail',
    props: (route) => ({ ...route.params, appName: 'workflows' }),
  },
  {
    path: '/workflows/workflowruns/import/galaxy',
    name: 'workflowRunImportGalaxyView',
    component: WorkflowRunImportGalaxyView,
    meta: {
      requiresAuth: true,
      title: 'Import Galaxy Workflow Invocation',
    },
    props: (route) => ({
      ...route.params,
      appName: 'workflows',
      modelName: 'workflowruns',
    }),
  },
]

export default workflowRoutes
